import DetalheTurma from './DetalheTurma';

export default DetalheTurma;
